<template>
  <div id="app">
    <vue-terminal 
      :title="title"
      :prompt="prompt"
      :task-list="taskList"
      :defaultTask="defaultTask"
      :command-list="commandList" />
  </div>
</template>

<script>
//import VueTerminal from 'vue-terminal'
import VueTerminal from '@/components/VueTerminal'

const mockData = [
  { message: 'Initialisiere Terminal ...' },
  { message: 'Würfle Bits ...' },
  { message: 'Mische Farben an ...' },
  { message: 'Trockne Hintergrund ...' },
  { message: 'Fertig: Willkommen bei Zak IT - Beratung und Softwareentwicklung!' },
]

const skillData = [
  {
    key: 'Code- und Buildmanagement',
    value: 'Git Maven Docker Jenkins Sonar Nexus'
  },
  {
    key: 'Fachgebiete',
    value: 'Telematikinfrastruktur PKI Konnektor Kartenterminal Smartcard eGK HBA SMC'
  },
  {
    key: 'Frontend',
    value: 'VueJS AngluarJS Bootstrap jQuery JavaFx Vaadin Eclipse-RCP'
  },
  {
    key: 'Java Frameworks',
    value: 'Spring* BouncyCastle JAX-* OSGi'
  },  
  {
    key: 'Persistenz',
    value: 'MongoDB Elasticsearch MySQL JPA Hibernate'
  },
  {
    key: 'Sprachen',
    value: 'Java JavaScript TypeScript'
  },
  {
    key: 'Test',
    value: 'Cucumber JUnit Mockito Selenium TestNG'
  },
  {
    key: 'Web Technologien',
    value: 'REST SOAP Netty Thymeleaf Tomcat Jetty Undertow'
  },
  {
    key: 'Weitere',
    value: 'Entwicklung Architektur Test Scrum QS'
  }
]

export default {
  name: 'App',
  components: {
    VueTerminal
  },
  data () {
      return {
        title: "zak@it:~# ",
        prompt: "zak@it:~# ",
        defaultTask: "init",
        skillMap: skillData,
        commandList: {
          version: {
            description: 'Gibt die Projektversion aus',
            messages: [
             { message: '1.0.0' }
            ]
          }
        },
        taskList: {
          cv: {
            description: 'Öffnet mein Web-CV',
            cv(pushToList) {
              const p = new Promise((resolve) => {
                pushToList({ message: 'Öffne CV ...' })
                let url = "https://link.gravitycv.com/zakit"
                window.open(url, '_blank')
                resolve({ message: 'CV geöffnet' })
              })
              return p;
            }
          },           
          init: {
            description: 'Initialisiert das Terminal',
            init(pushToList) {
              let i = 0;
              const p = new Promise(resolve => {
                const interval = setInterval(() => {
                  pushToList(mockData[i]);
                  i++
                  if (!mockData[i]) {
                    clearInterval(interval)
                    resolve({message: '' })
                  }
                }, 1000);
              })
              return p
            }
          },
          linkedin: {
            description: 'Öffnet mein LinkedIn-Profil',
            linkedin(pushToList) {
              const p = new Promise((resolve) => {
                pushToList({ message: 'Öffne LinkedIn-Profil ...' })
                let url = "https://www.linkedin.com/in/saschazak/"
                window.open(url, '_blank')
                resolve({ message: 'LinkedIn-Profil geöffnet' })
              })
              return p;
            }
          },
          skills: {
            description: 'Gibt ausgewählte Skills aus',
            skills(pushToList) {
              const p = new Promise((resolve) => {
                skillData.map(skill => {
                  pushToList({type: 'info', label: skill.key + ': ', message: skill.value })
                })
                resolve({ message: 'Skillauswahl ausgegeben' })
              })
              return p;
            } 
          },
          xing: {
            description: 'Öffnet mein Xing-Profil',
            xing(pushToList) {
              const p = new Promise((resolve) => {
                pushToList({ message: 'Öffne Xing-Profil ...' })
                let url = "https://www.xing.com/profile/Sascha_Zak/cv"
                window.open(url, '_blank')
                resolve({ message: 'Xing-Profil geöffnet' })
              })
              return p;
            }
          }
        }
      }
    }
}
</script>

<style>
body  {
  background-color: black;
}
a, a:visited, a:hover, a:active {
    text-decoration: underline;
    color: greenyellow;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  width:100%;
  height:500px;
  text-align:left;
  vertical-align:top;
}
</style>
